export default __webpack_public_path__ + "images/10e74ae3c6b36b2aca9c01834f6664d6-fall_banner_tablet.webp";